export const MODEL_PROMPT_RESPONSE = `
Some text before the code block!
Some text before the code block!
\`\`\`turtle
@prefix : <urn:skynet:> .
@prefix so: <https://schema.org/> .
@prefix m: <urn:stardog:modules:> .
@prefix rdfs: <http://www.w3.org/2000/01/rdf-schema#> .
@prefix skos: <http://www.w3.org/2004/02/skos/core#> .

<urn:skynet:Customer360DataModel>
  a m:DataModel ;
  rdfs:label "Customer 360 Data Model" ;
  rdfs:comment "A data model designed to improve customer satisfaction by providing a complete view of customers across multiple interaction channels and touchpoints." ;
  dc:date "2022-11-01T00:00:00Z"^^so:DateTime ;
  dc:publisher "Skynet Inc." ;
  dc:rights "Copyright (c) 2022 Skynet Inc." .

:Customer
  a owl:Class ;
  rdfs:label "Customer" ;
  rdfs:comment "A person, business, or other entity that has interacted with our company at some point." ;
  skos:example "John Doe, Acme Inc." ;
  m:icon "person" .

:CustomerInteraction
  a owl:Class ;
  rdfs:label "Customer Interaction" ;
  rdfs:comment "A record of any interaction or touchpoint with a customer." ;
  skos:example "Phone call, Facebook message, In-store purchase" ;
  m:icon "document-text" .

:customerName
  a owl:DatatypeProperty ;
  rdfs:label "Customer Name" ;
  rdfs:comment "The name of the customer." ;
  skos:example "John Doe" ;
  so:rangeIncludes so:Text .

:customerID
  a owl:DatatypeProperty ;
  rdfs:label "Customer ID" ;
  rdfs:comment "The unique identifier of the customer." ;
  skos:example "123456" ;
  so:rangeIncludes so:Text .

:customerEmail
  a owl:DatatypeProperty ;
  rdfs:label "Customer Email" ;
  rdfs:comment "The email address of the customer." ;
  skos:example "john.doe@example.com" ;
  so:rangeIncludes so:Text .

:interactionType
  a owl:DatatypeProperty ;
  rdfs:label "Interaction Type" ;
  rdfs:comment "The type of customer interaction." ;
  skos:example "Phone call, Email, Social media post" ;
  so:rangeIncludes so:Text .

:interactionDateTime
  a owl:DatatypeProperty ;
  rdfs:label "Interaction Date and Time" ;
  rdfs:comment "The date and time of the customer interaction." ;
  skos:example "2022-10-30T10:15:00Z"^^so:DateTime ;
  so:rangeIncludes so:DateTime .

:customer
  a owl:ObjectProperty ;
  rdfs:label "Has Customer" ;
  rdfs:comment "The customer associated with a customer interaction." ;
  so:domainIncludes :CustomerInteraction ;
  so:rangeIncludes :Customer .
\`\`\`

This is an extra sentence after the code block!
This is an extra sentence after the code block!

`.trim();
